export const ADD_SCHEDULED_MESSAGE          = 'ADD_SCHEDULED_MESSAGE';
export const REMOVE_SCHEDULED_MESSAGE       = 'REMOVE_SCHEDULED_MESSAGE';
export const SET_SCHEDULED_MESSAGES         = 'SET_SCHEDULED_MESSAGES';
export const SET_SCHEDULED_META             = 'SET_SCHEDULED_META';
export const SET_SENT_SCHEDULED_MESSAGES    = 'SET_SENT_SCHEDULED_MESSAGES';
export const SEND_SCHEDULED_MESSAGE         = 'SEND_SCHEDULED_MESSAGE';
export const SELECT_SCHEDULED_MESSAGE       = 'SELECT_SCHEDULED_MESSAGE';
export const UPDATE_SCHEDULED_MESSAGE       = 'UPDATE_SCHEDULED_MESSAGE';
export const RESET_SELECT_SCHEDULED_MESSAGE = 'RESET_SELECT_SCHEDULED_MESSAGE';
